import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile-creation-wizard ff-bottom-fixed-cta" }
const _hoisted_2 = { class: "profile-creation-wizard__container" }
const _hoisted_3 = { class: "profile-creation-wizard__content-actions" }
const _hoisted_4 = { class: "profile-creation-wizard__content" }
const _hoisted_5 = { class: "details-form__item" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "details-form__item__title" }, "TBD", -1)
const _hoisted_7 = { class: "profile-creation-wizard__content-footer" }

import {StepNavigator} from '@/profile-creation-wizard/common/step/StepNavigator';
    import StepActions from '@/profile-creation-wizard/common/ui/step/StepActions.vue';
    import StepMobileHeader from '@/profile-creation-wizard/common/ui/step/StepMobileHeader.vue';
    import {computed, ref} from 'vue';
    import {useRouter} from 'vue-router';
    import LinkedinImportDialog from './linkedin-import-dialog/LinkedinImportDialog.vue';

    const stepName = 'completion_linkedin_import';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'LinkedInImportStep',
  setup(__props) {

    const router = useRouter();

    const hasValidFieldPart = ref(false);
    const isOpenedLinkedInDialog = ref(false);
    const meta = computed(() => router.currentRoute.value.meta);
    const progressPercentage = computed(() => meta.value.progressPercentage);
    const stepNavigator = new StepNavigator(router, meta.value.previousStep, meta.value.nextStep);
    // TODO skip step should depend on:
    // const isStepOptionnal = computed(() => meta.value.funnelMode === ProfileCreationFunnelMode.CLASSIC);

    function handleOpenLinkedInDialog() {
        isOpenedLinkedInDialog.value = true;
    }
    function handleCloseLinkedInDialog() {
        isOpenedLinkedInDialog.value = false;
    }

    function goToPrevious(): void {
        stepNavigator.previous();
    }
    function goNext(): void {
        stepNavigator.next();
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_progress_bar = _resolveComponent("joy-progress-bar")!
  const _component_joy_button = _resolveComponent("joy-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_joy_progress_bar, { percentage: progressPercentage.value }, null, 8, ["percentage"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(StepMobileHeader, {
            "step-name": stepName,
            "onClick:previous": goToPrevious
          }),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_joy_button, { onClick: handleOpenLinkedInDialog }, {
              default: _withCtx(() => [
                _createTextVNode("Show LinkedIn dialog")
              ]),
              _: 1
            })
          ]),
          _createVNode(LinkedinImportDialog, {
            "is-opened": isOpenedLinkedInDialog.value,
            "onLinkedinDialog:cancel": handleCloseLinkedInDialog,
            "onLinkedinDialog:confirm": handleCloseLinkedInDialog
          }, null, 8, ["is-opened"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_joy_progress_bar, {
            percentage: progressPercentage.value,
            mode: "mobile"
          }, null, 8, ["percentage"]),
          _createVNode(StepActions, {
            "step-name": stepName,
            "show-button-skip": true,
            "show-button-previous": false,
            "is-disabled-button-next": !hasValidFieldPart.value,
            "is-hidden-button-skip": hasValidFieldPart.value,
            "onClick:next": goNext,
            "onClick:skip": goNext,
            "onClick:previous": goToPrevious
          }, null, 8, ["is-disabled-button-next", "is-hidden-button-skip"])
        ])
      ])
    ])
  ]))
}
}

})